export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/e7df50ca80c925c200e2a3c8cab6ca2b.jpg"
          alt="Sell house with title issues - Professional title examination"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Sell Your House with Title Issues Fast
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          We Buy Houses with Liens, Clouded Titles, Probate Issues & Boundary Disputes in El Paso
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="tel:9152065814"
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Cash Offer Now
          </a>
          <a 
            href="#contact"
            className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Free Title Consultation
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">We Handle All Liens</h3>
            <p className="text-white/90 text-sm">Tax liens, mechanic's liens, judgment liens - we pay them off at closing</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-list-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Clear Clouded Titles</h3>
            <p className="text-white/90 text-sm">Missing heirs, unrecorded deeds, chain of title issues - we solve them all</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Close in 7-14 Days</h3>
            <p className="text-white/90 text-sm">Fast cash offers with title company protection - no waiting months</p>
          </div>
        </div>
      </div>
    </section>
  );
}